import * as React from 'react';
const SvgFullyManaged = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M103.989 6.181v49.13c0 2.299-1.884 4.18-4.188 4.18H24.408c-2.303 0-4.188-1.881-4.188-4.18V6.18c0-2.3 1.885-4.181 4.188-4.181h75.183c2.514 0 4.398 1.882 4.398 4.181Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M51.633 17.68v26.132l20.943-13.17-20.943-12.963ZM103.989 77.68v33.867h-83.77V77.68c0-2.927 2.304-5.227 5.236-5.227h73.299c2.932 0 5.235 2.3 5.235 5.227Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="m72.576 101.094-16.754 10.453h-4.189V88.132l20.943 12.962ZM2 111.547v2.718C2 118.655 5.56 122 9.749 122H114.25c4.398 0 7.749-3.554 7.749-7.735v-2.718H2ZM9.749 46.32h10.47M103.989 46.32h10.471"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M20.22 35.868h-2.513c-4.398 0-7.749 3.554-7.749 7.735v67.944M103.989 35.868h2.513c4.398 0 7.749 3.554 7.749 7.735v67.944"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SvgFullyManaged;
